<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <template v-if="productColors.length == 0">
          <v-row justify="center" class="mt-10">
            <v-col cols="12" md="10" xs="12">
              <v-row justify="center">
                <v-col cols="12" lg="4" md="6" sm="8" xs="12">
                  <v-card style="border: 0" outlined elevation="0">
                    <v-card-title class="justify-center">
                      <v-icon size="80" color="primary">search_off</v-icon>
                    </v-card-title>
                    <v-card-title class="justify-center">
                      <p class="text--primary text-center">
                        ¡Lo sentimos!
                      </p>
                    </v-card-title>
                    <v-card-text>
                      <div class="text--primary text-center">
                        No encontramos ningún resultado para tu búsqueda <p style="color: red">"{{ $route.query.q }}"</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row justify="center" class="mt-8">
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-row>
                <v-col cols="12" class="d-flex align-end flex-column">
                    <v-select
                      v-model="orderBy"
                      :items="select.filters"
                      item-value="id"
                      item-text="name"
                      label="Ordenar por:"
                      dense
                      outlined
                      @change="changeOrderBy"
                    ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-row>
                <template v-for="(item, index) in shownCards">
                  <v-col
                    :key="item.id"
                    cols="6"
                    lg="3"
                    md="4"
                    sm="6"
                    xs="6"
                  >
                    <v-card>
                      <v-img
                        :src="item.product_color_image[0].image"
                        :lazy-src="item.product_color_image[0].image.replace('300x300', '100x100')"
                        :key="item.product_color_image[0].image"
                        :min-height="$vuetify.breakpoint.xsOnly ? 130 : 180"
                        height="auto"
                        @click="productImageSelected(item)"
                        :style="[(item.stock == 0) ? {'filter': 'grayscale(100%)', '-webkit-filter': 'grayscale(100%)'} : {}]"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                        <template v-if="item.stock == 0">
                          <div class="text-right">
                            <v-chip
                              class="ma-2 short"
                              color="pink"
                              label
                              text-color="white"
                            >
                              <v-icon left>
                                mdi-label
                              </v-icon>
                              <b :style="[($vuetify.breakpoint.xsOnly) ? {'font-size': '9px'} : {}]">PRODUCTO AGOTADO</b>
                            </v-chip>
                          </div>
                        </template>
                        <template v-if="item.product.off && !$vuetify.breakpoint.xsOnly">
                          <div class="text-right">
                            <v-chip
                              class="ma-2 short"
                              color="pink"
                              label
                              text-color="white"
                            >
                              <v-icon left>
                                mdi-label
                              </v-icon>
                              <b class="body-2">- {{ item.product.off }}%</b>
                            </v-chip>
                          </div>
                        </template>
                      </v-img>

                      <v-card-title class="justify-center mt-n2">
                        <span class="input-group-product">
                          {{ item.product.group }}
                        </span>
                      </v-card-title>

                      <v-card-text>
                        <v-row align="center" class="mx-0">
                          <v-rating
                            :value="item.product.average_star ? item.product.average_star : 5"
                            color="secondary"
                            dense
                            half-increments
                            readonly
                            size="16"
                          ></v-rating>
                        </v-row>

                        <div class="my-3 product-name">
                          <span class="input-name-product" @click="productImageSelected(item)">
                            {{ item.product.name }}
                          </span>
                        </div>
                      </v-card-text>

                      <v-card-title class="mt-n10">
                        <v-row no-gutters>
                          <template v-if="item.product.off">
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 text-right conetnido" style="border: 0" outlined elevation="0">
                                S/ {{ item.product.sale_price }}
                              </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                                S/ {{ item.product.regular_price }}
                              </v-card>
                            </v-col>
                            <template v-if="$vuetify.breakpoint.xsOnly">
                              <v-col cols="12" sm="12" xs="12">
                                <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                                  <v-chip
                                    color="pink"
                                    label
                                    text-color="white"
                                  >
                                    <v-icon left>
                                      mdi-label
                                    </v-icon>
                                    - {{ item.product.off }}%
                                  </v-chip>
                                </v-card>
                              </v-col>
                            </template>
                          </template>
                          <template v-else>
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                                S/ {{ item.product.regular_price }}
                              </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" xs="12">
                              <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                                &nbsp;
                              </v-card>
                            </v-col>
                            <template v-if="$vuetify.breakpoint.xsOnly">
                              <v-col cols="12" sm="12" xs="12">
                                <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                                  &nbsp;
                                </v-card>
                              </v-col>
                            </template>
                          </template>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </template>
              </v-row>

              <v-row justify="center" class="pt-8 pb-8">
                <v-pagination v-model="page" :length="length" @input="onPageChange"></v-pagination>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'Products',
    components: {
      DefaultLayout
    },
    metaInfo() {
      return {
        title: `${this.$route.query.q} - Dino Toys`,
        meta: [
          { name: 'description', content: 'Lo mejor en ' + this.$route.query.q + ' - Dino Toys' },
          { property: 'og:title', content: this.$route.query.q + ' - Dino Toys' },
          { property: 'og:site_name', content: 'Dino Toys' },
          { property: 'og:description', content: 'Lo mejor en ' + this.$route.query.q },
          { property: 'og:type', content: 'profile' },
          { property: 'og:url', content: 'https://www.dino-toys.com/#/products?q=' + this.$route.query.q },
          { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Flogos%2Flogo_meta.jpg?alt=media&token=4a5db43f-4ff5-4d47-99e4-bea4fab9432b' }
        ]
      }
    },
    data () {
      return {
        productColors: [],
        page: this.$route.query.page,
        length: null,
        count: 16,
        orderBy: null,
        select: {
          filters: [
            { id: 'OrderByPriceASC', name: 'Precio más bajo' },
            { id: 'OrderByPriceDESC', name: 'Precio más alto' },
            { id: 'OrderByReleaseDateDESC', name: 'Lo más nuevo' },
            { id: 'OrderByBestDiscountDESC', name: 'Mejor descuento' }
          ],
        }
      }
    },
    computed: {
      shownCards () {
        window.scrollTo(0, 0);
        const { page, count, productColors } = this;
        // const number = Math.ceil(productColors.length / count);
        // return productColors.slice((page - 1) * count, page * count);
        return productColors
      }
    },
    methods: {
      findProduct() {
        this.productColors = [];
        const query = this.$route.query.q.concat('', this.orderBy ? '&orderBy=' + this.orderBy : '&orderBy=OrderByReleaseDateDESC').concat('&page=', + this.$route.query.page ? this.$route.query.page : 1);
        const url = process.env.DINO.PATH.GET_PRODUCTS_SEARCH + query;
        axios.get(url)
        .then(response => {
          const page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
          this.productColors = response.data.rows;
          this.length = Math.ceil(response.data.count / this.count);
          this.page = page;
        })
        .catch(err => {

        });
      },

      increment(index, item) {
        item.amount = parseInt(item.amount) + 1;
        this.productColors.splice(index, 1, item)
      },

      decrement(index, item) {
        item.amount = parseInt(item.amount) - 1;
        this.productColors.splice(index, 1, item)
      },

      productImageSelected: function(item) {
        this.$router.push({ name: 'ProductDetail', params: { 'productColorId': item.id, 'productId': item.product.id, 'productName': item.product.name } })
      },

      onPageChange: function(page) {
        this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.go(this.$router.currentRoute)
      },

      changeOrderBy: function(value) {
        this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: value, page: this.page } }).catch(err => {});
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.go(this.$router.currentRoute)
      }
    },
    mounted: function() {
      this.orderBy = this.$route.query.orderBy ? this.$route.query.orderBy : 'OrderByReleaseDateDESC';
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
      this.findProduct();
    },
    watch: {
      '$route.query.q'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
      },
      '$route.query.page'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
      },
      '$route.query.orderBy'() {
        // this.$router.go(0)
        setTimeout(function(){
          window.location.reload();
        });
        // this.$router.push({ name:'Products', query: { q: this.$route.query.q, orderBy: this.orderBy, page: this.page } }).catch(err => {});
      }
    }
  }
</script>
<style scoped>
  .product-name {
    width: 100%;
    height:45px;
    color:black;
    overflow:hidden;
    text-overflow: ellipsis;
  }

  .btn-add-cart {
    width: 100%;
    font-size: 11px !important
  }

  .input-price >>> input[type='number'] {
    -moz-appearance:textfield;
    text-align: center;
  }

  .input-price >>> input::-webkit-outer-spin-button,
  .input-price >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    text-align: center;
  }

  .input-group-product {
    font-size: 14px;
    color: #777;
    text-transform: uppercase
  }

  .input-name-product {
    font-size: 14px;
    text-transform: uppercase
  }

  .conetnido {
    font-size: 90%;
    @media only screen and (min-width: 600px) {
        font-size: 94%;
    }
    @media only screen and (min-width: 1000px) {
        font-size: 98%;
    }
    @media only screen and (min-width: 1200px) {
        font-size: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Products.vue